import { io } from "socket.io-client";

/**
 * MARITIME LOGISTICS UPLINK (v3.3 - Dynamic Environment & Tenant Isolation)
 */

const KOYEB_URL = "https://golden-shaina-maritimesupplysuites-ed826a4c.koyeb.app";
const LOCAL_URL = "http://localhost:5000"; 

// Detect environment
const isLocal = window.location.hostname === "localhost";
const BASE_URL = isLocal ? LOCAL_URL : KOYEB_URL;

const DATA_GATEWAY = BASE_URL.replace(/\/api$/, "").replace(/\/$/, "");
const HANDSHAKE_KEY = "maritime_ops_secure_2026";

// Extract stored tenant scope for socket handshake authentication
const adminSession = JSON.parse(localStorage.getItem("adminUser") || "{}");
const userSession = JSON.parse(localStorage.getItem("user") || "{}");
const tenantId = adminSession.adminId || userSession.adminId || localStorage.getItem("adminId") || "";

const socket = io(DATA_GATEWAY, {
  path: "/socket.io",
  autoConnect: false, 
  transports: ["websocket", "polling"], 
  withCredentials: true,       
  reconnection: true,
  reconnectionAttempts: Infinity, 
  reconnectionDelay: 2000,      
  timeout: 45000,
  forceNew: true,
  auth: {
    token: localStorage.getItem("token") || localStorage.getItem("adminToken") || "",
    tenantId: tenantId
  },
  extraHeaders: {
    "x-ops-handshake": HANDSHAKE_KEY,
    "x-admin-secret": HANDSHAKE_KEY,
    "x-tenant-id": tenantId
  }
});

/* ================= NETWORK TELEMETRY ================= */

socket.on("connect", () => {
  console.log(
    "%c[UPLINK] Terminal Link Established:", 
    "color: #10b981; font-weight: bold; font-family: monospace;", 
    socket.id
  );
});

// Joins the private or tenant room once the server confirms connection
socket.on("authenticated", (data) => {
  const targetId = typeof data === "object" ? data.userId : data;
  const tId = typeof data === "object" ? data.adminId : tenantId;

  if (targetId) {
    const joinPayload = tId ? { role: "admin", adminId: tId } : String(targetId);
    socket.emit("join", joinPayload);
    console.log(`%c[SYSTEM] Joined Tenant Scope Room`, "color: #3b82f6;");
  }
});

socket.on("connect_error", (error) => {
  if (error.message && error.message.toLowerCase().includes("namespace")) {
    return;
  }
  console.error("%c[SYSTEM] Gateway Error:", "color: #ef4444;", error.message);
});

socket.on("disconnect", (reason) => {
  console.warn("%c[SYSTEM] Connection Lost:", "color: #f59e0b;", reason);
  if (reason === "io server disconnect") {
    socket.connect();
  }
});

export default socket;